/**
 * isMqq
 * @author marvinqi
 * @createTime 2017/9/20
 */
import getUA from './getUA'

export default function () {
  return /(ipad|iphone|ipod).*? (ipad)?qq\/([\d.]+)|\bv1_and_sqi?_([\d.]+)(.*? qq\/([\d.]+))?/.test(getUA())
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isMQQ.js